import { axiosInstance } from "../axiosInstance";

export const getAllPackages =async () => {
  const instance =await axiosInstance();
  return await instance.get("/package");
};
